import {
    format,
    getDaysInMonth,
    nextFriday,
    nextMonday,
    nextSaturday,
    nextSunday,
    nextThursday,
    nextTuesday,
    nextWednesday,
} from 'date-fns';

const currentDate = new Date();
export const daysOfWeek = (f = 'iiiii'): string[] => [
    ...[
        nextMonday(currentDate),
        nextTuesday(currentDate),
        nextWednesday(currentDate),
        nextThursday(currentDate),
        nextFriday(currentDate),
        nextSaturday(currentDate),
        nextSunday(currentDate),
    ].map(dOW => format(dOW, f)),
];

export const daysOfMonth = (specificDate?: Date): string[] => [
    ...Array.from(Array(getDaysInMonth(specificDate ?? currentDate)), (_, i) => `${i + 1}`),
];

export const toISOLocalDate = (date: Date | null): string => {
    if (!date) return '';
    return format(date, 'yyyy-MM-dd');
};

export const getDefaultDateForInhibitionTimeout = (): Date => {
    return new Date('2025-01-01T00:00:00Z');
};

export const getTimezoneOffsetForIot = (): number => {
    /* The time - zone offset is the difference, in minutes, between UTC and local time.
    Note that this means that the offset is positive if the local timezone is behind UTC and negative if it is ahead.
    For example, if your time zone is UTC + 10(Australian Eastern Standard Time),
        -600 will be returned. */
    //We want to give 1 for UTC+1 and -1 for UTC-1
    return -(new Date().getTimezoneOffset() / 60);
};

export const getDateAtMidnight = (date?: Date): Date => {
    const newDate = new Date(date ?? new Date());
    newDate.setHours(0, 0, 0, 0);
    return newDate;
};
